export type AutoScrollTarget =
  | { kind: 'next'; id: number }
  | { kind: 'bottom' }
  | null;

/**
 * Decides where to auto-scroll after a complement selection.
 * Only fires on the transition from below max to reaching max, so changing
 * an option inside an already-complete group does not re-scroll.
 */
export function getAutoScrollTarget(
  choices: { id: number }[],
  groupId: number,
  max: number,
  prevTotal: number,
  newTotal: number
): AutoScrollTarget {
  if (!max) return null;
  if (prevTotal >= max || newTotal < max) return null;

  const index = choices.findIndex((choice) => choice.id === groupId);
  if (index < 0) return null;

  const next = choices[index + 1];
  return next ? { kind: 'next', id: next.id } : { kind: 'bottom' };
}
